module.exports = __webpack_public_path__ + "img/s-resume-clinic.83970516.svg";